"use client";

import type { ReactNode } from "react";

import { useCatalogResults } from "../../hooks/useCatalogResults.hook";
import { CatalogEmptyState } from "./CatalogEmptyState/CatalogEmptyState";

type Props = {
  userAgent?: string | null;
  children: ReactNode;
};

/**
 * Decide, no client, entre a experiência de 0 resultados e o conteúdo do catálogo.
 *
 * O CatalogBlock (server) só reavalia o total no render server. Filtros aplicados
 * no client (nuqs + refetch TanStack) não re-executam o server, então a decisão
 * precisa acontecer aqui para remover todo o conteúdo (breadcrumb, título, filtros,
 * ordenação, grid) e exibir apenas o empty state — igual ao caminho server.
 *
 * Só decide após o fetch assentar (`!isLoading && !query.isFetching`) para não
 * piscar o empty state durante o refetch (o hook paginado usa placeholderData).
 */
export function CatalogContent({ userAgent, children }: Readonly<Props>) {
  const { totalProducts, isLoading, query } = useCatalogResults({ userAgent });

  const hasNoResults = totalProducts === 0 && !isLoading && !query.isFetching;

  if (hasNoResults) {
    return <CatalogEmptyState />;
  }

  return <>{children}</>;
}
